import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import {LeadCaptureService} from './shared/lead-capture/lead-capture.service';
import {DevelopmentNoticeComponent} from './shared/development-notice/development-notice.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, DevelopmentNoticeComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {

  constructor(protected readonly leadCaptureService: LeadCaptureService) {


  }  protected readonly navLinks = [
    { label: 'Home', path: '/landing' },
    { label: 'Features', path: '/features' },
    { label: 'Game Modes', path: '/game-modes' },
    { label: 'Heroes', path: '/heroes' },
    { label: 'Factions', path: '/factions' },
    { label: 'Roadmap', path: '/roadmap' },
    { label: 'News', path: '/news' }
  ];

  protected beginLegion(): void {
    this.leadCaptureService.openBetaSignup();
  }
}
